import React, { useState } from "react";
import "./style.css";
import PolitykaPrywatnosci from "./PolitykaPrywatnosci";

const modelImages = {
  "160YA": "https://aureusagro.pl/wp-content/uploads/2021/04/160.png",
  "166YA": "https://aureusagro.pl/wp-content/uploads/2021/04/160.png",
  "180YA": "https://aureusagro.pl/wp-content/uploads/2021/04/180-ya-2.jpg",
  "195YA": "https://aureusagro.pl/wp-content/uploads/2021/04/195.png",
  "305YA": "https://aureusagro.pl/wp-content/uploads/2021/04/305.png",
  "505YA": "https://aureusagro.pl/wp-content/uploads/2021/04/500.png",
  "605YA": "https://aureusagro.pl/wp-content/uploads/2021/04/605_transparent1.png",
};

const modelGalleries = {
  "160YA": [
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1613-Kopiowanie.jpg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1610-Kopiowanie.jpg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1585-Kopiowanie.jpg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1593-Kopiowanie.jpg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1570-Kopiowanie.jpg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1575-Kopiowanie.jpg",
  ],

  "166YA": [
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1613-Kopiowanie.jpg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1610-Kopiowanie.jpg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1585-Kopiowanie.jpg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1593-Kopiowanie.jpg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1570-Kopiowanie.jpg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1575-Kopiowanie.jpg",
  ],

  "180YA": [],

  "195YA": [
    "https://aureusagro.pl/wp-content/uploads/2021/04/1902.jpg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/190.jpg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/1903.jpg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/195-ya-kabine.jpg",
  ],

  "305YA": [
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1516.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1523.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1524.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1526.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1532.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1710.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1498.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1501.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1505.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1506.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1512.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1514.jpeg",
  ],

  "505YA": [
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1556-2.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1557-2.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1559-2.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1620-2.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1646-2.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1657-2.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1696-2.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1699-2.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1703-2.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1537-2.jpeg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/DSC_1547-2.jpeg",
  ],

  "605YA": [
    "https://aureusagro.pl/wp-content/uploads/2021/04/paratouchmatrix766411a8a50f858072.jpg",
    "https://aureusagro.pl/wp-content/uploads/2021/04/605ya-2.jpg",
  ],
};


const modelDescriptions = {
  "166YA": "https://aureusagro.pl/striegel-160ya/",
  "160YA": "https://aureusagro.pl/striegel-160ya/",
  "180YA": "https://aureusagro.pl/striegel-180ya/",
  "195YA": "https://aureusagro.pl/striegel-195ya/",
  "305YA": "https://aureusagro.pl/striegel-305ya/",
  "505YA": "https://aureusagro.pl/striegel-505ya/",
  "605YA": "https://aureusagro.pl/striegel-605ya/",
};



const modelPrices = {
  "166YA": "95 200 zł netto",
  "160YA": "107 685 zł netto",
  "180YA": "124 710 zł netto",
  "195YA": "148 970 zł netto",
  "305YA": "154 444 zł netto",
  "505YA": "173 657 zł netto",
  "605YA": "199 620 zł netto",
};

const equipmentImages = {
  "Łyżka uniwersalna": "https://aureusagro.pl/wp-content/uploads/2026/08/LYZKA-UNIWERSALNA-A140.png",
  "Widło-krokodyl": "https://aureusagro.pl/wp-content/uploads/2026/08/WIDLO-KROKODYL-B216.png",
  "Szuflo-Krokodyl": "https://aureusagro.pl/wp-content/uploads/2026/08/SZUFLO-KROKODYL-A516.png",
  "Łyżka wielofunkcyjna": "https://aureusagro.pl/wp-content/uploads/2026/08/LYZKA-WIELOFUNKCYJNA-4w1.png",
  "Chwytak do bel jednosiłownikowy": "https://aureusagro.pl/wp-content/uploads/2026/08/CHWYTAK-DO-BEL-JEDNOSILOWNIKOWY.png",
  "Łyżka wielofunkcyjna 4w1": "https://aureusagro.pl/wp-content/uploads/2026/08/LYZKA-WIELOFUNKCYJNA-4w1.png",
  "Widły do palet": "https://aureusagro.pl/wp-content/uploads/2026/08/WIDLY-DO-PALET-PALECIAK.png",
  "Adapter Euro/Striegel": "https://aureusagro.pl/wp-content/uploads/2026/08/ADAPTER-EUROSTRIEGEL-R117.png",
  "Bez osprzętu": null
};


export default function FormularzStriegel() {
  const [model, setModel] = useState("160YA");
  const [kabina, setKabina] = useState(null);
  const [osprzet, setOsprzet] = useState([]);
  const [finansowanie, setFinansowanie] = useState(null);
  const [wariant, setWariant] = useState(null);
  const [kontakt, setKontakt] = useState({ imie: '', nazwisko: '', email: '', telefon: '' });
  const [obraz, setObraz] = useState(modelImages["160YA"]);
  const [wiadomosc, setWiadomosc] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [seconds, setSeconds] = useState(0);
const [zgoda, setZgoda] = useState(false);
const [showPolicy, setShowPolicy] = useState(false);
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = () => {
    if (!model || !kabina || !kontakt.imie || !kontakt.nazwisko || !kontakt.email || !kontakt.telefon) {
      setWiadomosc("Proszę wypełnić wszystkie pola.");
      return;
    }

    if (!validateEmail(kontakt.email)) {
      setWiadomosc("Podaj poprawny adres e-mail.");
      return;
    }

if (!zgoda) {
  setWiadomosc("Musisz zaakceptować politykę prywatności.");
  return;
}

setIsSending(true);
setSeconds(0);


    const interval = setInterval(() => {
      setSeconds(prev => prev + 1);
    }, 1000);

    const dane = {
      model,
      kabina,
      osprzet: osprzet.join(", "),
      finansowanie,
      wariant,
      ...kontakt
    };

    fetch("https://aureusagro.pl/api/striegel_form.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dane)
    })
      .then(async res => {
        clearInterval(interval);
        const json = await res.json();

        if (res.ok) {
          window.location.href = "/oferta/potwierdzenie.html";
        } else {
          setWiadomosc("Błąd: " + (json.error || "Nieznany błąd"));
          setIsSending(false);
        }
      })
      .catch(() => {
        clearInterval(interval);
        setWiadomosc("Błąd połączenia z serwerem.");
        setIsSending(false);
      });
  };

  const handleModel = (value) => {
    setModel(value);
    setObraz(modelImages[value]);
  };

const handleOsprzet = (value) => {
  let updated = [];

  if (value === "Bez osprzętu") {
    // zaznaczenie "Bez osprzętu" usuwa wszystkie inne opcje
    updated = ["Bez osprzętu"];
  } else {
    // usuwamy "Bez osprzętu", jeśli było zaznaczone
    const filtered = osprzet.filter(o => o !== "Bez osprzętu");

    // przełączanie wybranego osprzętu
    updated = filtered.includes(value)
      ? filtered.filter(o => o !== value)
      : [...filtered, value];
  }

  setOsprzet(updated);

  // zmiana zdjęcia
  if (value === "Bez osprzętu") {
    setObraz(modelImages[model]);
  } else {
    setObraz(equipmentImages[value]);
  }
};

  const isEquipmentImage = Object.values(equipmentImages).includes(obraz);


  return (
    <>
      {/* 🔴 TOP BAR */}
      <div className="top-bar">
        Teraz limitowane fabryczne finansowanie, którego całkowity koszt to nawet +0,5% wartości maszyny.
      </div>

      <div className="container">
        <div className="form-section">

          <img
            src="https://www.ladowarkistriegel.pl/wp-content/uploads/brizy/imgs/logo-594x140x0x2x594x136x1618752091.png"
            alt="logo"
            className="logo"
          />

          <div className="finance-badge">
  <span className="badge-small">Sprawdź!</span>
  <span className="price-highlight">
    Promocyjne finansowanie fabryczne!
  </span>
</div>

          <h2 className="title">Ładowarki Striegel</h2>

          {/* MODEL */}
          <h3 className="section-title">Model ładowarki</h3>
          <div className="grid">
            {Object.keys(modelImages).map((m) => (
              <button
                key={m}
                onClick={() => handleModel(m)}
                className={`button ${model === m ? "selected" : ""}`}
              >
                {m}
              </button>
            ))}
          </div>

          {/* KABINA */}
          <h3 className="section-title">Przeszklona kabina?</h3>
          <div className="grid">
            {["TAK", "NIE"].map((o) => (
              <button
                key={o}
                onClick={() => setKabina(o)}
                className={`button ${kabina === o ? "selected" : ""}`}
              >
                {o}
              </button>
            ))}
          </div>

          {/* OSPRZĘT */}
          <h3 className="section-title">Osprzęt</h3>
          <div className="grid">
            {Object.keys(equipmentImages).map((e) => (
              <button
                key={e}
                onClick={() => handleOsprzet(e)}
                className={`button ${osprzet.includes(e) ? "selected" : ""}`}
              >
                {e}
              </button>
            ))}
          </div>

          {/* FINANSOWANIE */}
          <h3 className="section-title">Finansowanie</h3>
          <div className="grid">
            {["Gotówka", "Finansowanie fabryczne"].map((f) => (
              <button
                key={f}
                onClick={() => {
                  setFinansowanie(f);
                  setWariant(null);
                }}
                className={`button ${finansowanie === f ? "selected" : ""}`}
              >
                {f}
              </button>
            ))}
          </div>

          {finansowanie === "Finansowanie fabryczne" && (
            <div className="finansowanie-box">
              <h4>💰 Dostępne warianty promocyjnego finansowania:</h4>

              {[
                "30% wpłaty | 36 miesięcy | koszt całkowity 100,5%",
                "20% wpłaty | 48 miesięcy | koszt całkowity 103,5%",
                "10% wpłaty | 60 miesięcy | koszt całkowity 107,5%",
              ].map((w) => (
                <button
                  key={w}
                  onClick={() => setWariant(w)}
                  className={`button ${wariant === w ? "selected" : ""}`}
                >
                  ✔ {w}
                </button>
              ))}

              <div className="finansowanie-info">
                ✔ raty miesięczne<br />
                ✔ stałe oprocentowanie
              </div>
            </div>
          )}

          {/* DANE */}
          <h3 className="section-title">Dane</h3>

          <input
            placeholder="Imię"
            className="input"
            onChange={(e) => setKontakt({ ...kontakt, imie: e.target.value })}
          />

          <input
            placeholder="Nazwisko"
            className="input"
            onChange={(e) => setKontakt({ ...kontakt, nazwisko: e.target.value })}
          />

          <input
            placeholder="Email"
            className="input"
            onChange={(e) => setKontakt({ ...kontakt, email: e.target.value })}
          />

          <input
            placeholder="Telefon"
            className="input"
            onChange={(e) => setKontakt({ ...kontakt, telefon: e.target.value })}
          />
<div className="privacy-consent">
  <label className="privacy-label">
    <input
      type="checkbox"
      checked={zgoda}
      onChange={(e) => setZgoda(e.target.checked)}
    />

    <span>
      Oświadczam, że zapoznałem się z polityką prywatności i wyrażam zgodę
      na przetwarzanie moich danych osobowych przez Aureus Agro sp. z o.o.
      w celu przygotowania i przedstawienia oferty.
    </span>
  </label>

  <button
    type="button"
    className="policy-link"
    onClick={() => {
      console.log("klik");
      setShowPolicy(true);
    }}
  >
    Zobacz politykę prywatności
  </button>
</div>
      {showPolicy && (
  <div
    className="modal-overlay"
    onClick={() => setShowPolicy(false)}
  >
    <div
      className="modal-content"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="modal-close"
        onClick={() => setShowPolicy(false)}
      >
        ✕
      </button>

      <PolitykaPrywatnosci />
    </div>
  </div>
)}

          {/* PODSUMOWANIE */}
          <h3 className="section-title">Podsumowanie</h3>

          <p><strong>Model:</strong> {model}</p>
          <p><strong>Kabina:</strong> {kabina}</p>
          <p>
  <strong>Osprzęt:</strong>{" "}
  {osprzet.length > 0 ? osprzet.join(", ") : "Brak"}
</p>
          <p><strong>Finansowanie:</strong> {finansowanie}</p>

          {wariant && (
            <p><strong>Wariant:</strong> {wariant}</p>
          )}

          <button
            onClick={handleSubmit}
            className="submit"
            disabled={isSending}
          >
            {isSending ? `Wysyłam... (${seconds}s)` : "Zamawiam ofertę"}
          </button>

          <p className="submit-info">
            W godzinach pracy biura ofertę otrzymasz w ciągu 1h od wysłania zapytania
          </p>

          {wiadomosc && <div className="status-message">{wiadomosc}</div>}
        </div>

        {/* OBRAZ */}
        <div className="preview-section">
          <div className="image-wrapper">
{!isEquipmentImage && (
  <>
  <div className="price-badge">
    <span className="badge-small">Cena katalogowa</span>
    <span className="price-highlight">{modelPrices[model]}</span>
  </div>

  </>
  
)}


<img src={obraz} className="preview-image" />

{!isEquipmentImage && modelGalleries[model]?.length > 0 && (
  <div className="gallery">
    {modelGalleries[model].map((img, index) => (
      <img
        key={index}
        src={img}
        className="gallery-thumb"
        onClick={() => setObraz(img)}
        
      />
    ))}
  </div>
)}




</div>
        </div>
      </div>

      <div className="footer">
        <div className="footer-content">

          <p className="footer-main">
            Aureus Agro – Wyłączny dystrybutor niemieckich ładowarek przegubowych Striegel
          </p>

          <p>Fabryczna 3B, Andrychów, Poland, 34-120</p>
          <p className="footer-link">ladowarkistriegel.pl</p>

          <div className="footer-section">
            <strong>Siedziba główna Aureus Agro:</strong><br />
            +48 729 062 058 | kontakt@aureusagro.pl<br />
            Fabryczna 3B, 34-120 Andrychów
          </div>

          <div className="footer-section">
            <strong>Dział administracji i części zamiennych:</strong><br />
            +48 729 062 058<br />
            Jasnogórska 3 lok. B4, 44-100 Gliwice
          </div>

          <div className="footer-section">
            <strong>Plac pokazowy:</strong><br />
            Na Zakolu Wisły 6<br />
            30-729 Kraków
          </div>

        </div>
      </div>

    </>
    
  );
  
}
